import React from 'react';
import type { PurchaseOrderApproval, PurchaseOrderDisplayStatus } from '../../api/purchaseOrders';
import './PurchaseOrders.css';

/**
 * The status badge next to a purchase order. Takes `display_status`, so an Open PO
 * past its expected delivery date reads Overdue.
 */
const CLASS_BY_STATUS: Record<PurchaseOrderDisplayStatus, string> = {
  Open: 'po-status-pill--open',
  'Partially Received': 'po-status-pill--partial',
  'Fully Received': 'po-status-pill--received',
  Cancelled: 'po-status-pill--cancelled',
  Overdue: 'po-status-pill--overdue',
};

const PurchaseOrderStatusPill: React.FC<{ status: PurchaseOrderDisplayStatus }> = ({ status }) => (
  <span className={`po-status-pill ${CLASS_BY_STATUS[status] ?? 'po-status-pill--open'}`}>{status}</span>
);

/** Shown where the receiving buttons would be on an order that is not approved yet. */
export const PurchaseOrderApprovalTag: React.FC<{ approval: PurchaseOrderApproval }> = ({ approval }) => (
  <span
    className={`po-approval-tag${approval === 'Rejected' ? ' po-approval-tag--rejected' : ''}`}
    title="Use Edit on the purchase order to set its approval status to Approved before receiving it."
  >
    {approval === 'Rejected' ? 'Approval rejected' : 'Needs approval'}
  </span>
);

export default PurchaseOrderStatusPill;
